'use strict';

angular.module('mobile-apps').factory('ApproveAllLanguageEntries', ['$resource',
    function($resource) {
        return $resource('/v1/projects/:mobileAppId/languages/:languageId/entries/groups/:groupId/approve',
            {
              mobileAppId: '@mobileAppId',
              languageId: '@languageId',
              groupId: '@groupId'
            },
            {
                approve: {
                  method: 'POST',
                  cache: false
                }
            }
        );
    }
]);
